export default __webpack_public_path__ + "static/media/crm1.15f69993.svg";